(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/pay-game.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/pay-game.js');
"use strict";


const _svs$components$marke = svs.components.marketplace.accountSelector.helpers,
  getNewShares = _svs$components$marke.getNewShares,
  showIncreaseWarning = _svs$components$marke.showIncreaseWarning;
const format = svs.utils.format;
const log = new svs.core.log.Logger('account-selector');
const payGame = (_ref, finishPayment) => {
  let marketplaceAccount = _ref.marketplaceAccount,
    drawNumber = _ref.drawNumber,
    productId = _ref.productId;
  if (!marketplaceAccount) {
    finishPayment();
    return;
  }
  if (new Date(marketplaceAccount.buyinCloseTime).getTime() < Date.now()) {
    finishPayment();
  } else {
    getNewShares({
      drawNumber,
      productId
    }, (error, _ref2) => {
      let newShares = _ref2.newShares,
        newBalance = _ref2.newBalance;
      if (!error && newShares > 0) {
        showIncreaseWarning(newShares,
        format.Currency(newBalance), finishPayment);
        return;
      }
      if (error) {
        log.warn('Could not fetch group, ', error);
      }
      finishPayment();
    });
  }
};
setGlobal('svs.components.marketplace.accountSelector.payGame', payGame);

 })(window);